<template>
  <DialogoFormulario
    ref="dialog"
    :title="title"
    submit-text="Adicionar"
    :handler="handler"
    :width="400"
  >
    <template v-slot="{ form, errors }">
      <v-autocomplete
        v-model="form.produto_id"
        :loading="loadingProducts"
        outlined
        :error-messages="errors.produto_id"
        label="Produto"
        :items="produtos"
        item-value="id"
        item-text="nome"
      ></v-autocomplete>
      <v-text-field
        v-model="form.quantidade"
        outlined
        :error-messages="errors.quantidade"
        label="Quantidade"
      ></v-text-field>
    </template>
  </DialogoFormulario>
</template>

<script>
import DialogoFormulario from "@/components/dialogos/DialogoFormulario.vue";
import locacoes from "../../../services/locacoes";
import alerts from "@/mixins/alerts";

export default {
  mixins: [alerts],

  components: {
    DialogoFormulario
  },

  props: {
    localEstoqueId: Number
  },

  data() {
    return {
      produtos: [],
      loadingProducts: false,
      mode: "add"
    };
  },

  methods: {
    open(inicial, mode = "add") {
      this.$refs.dialog.open(inicial);
      this.loadProducts();
      this.mode = mode;
    },

    async handler(form) {
      let response = null;
      if (this.mode === "add") {
        response = await locacoes.locais_de_estoque.adicionarProduto(
          this.localEstoqueId,
          form
        );
      } else if (this.mode === "remove") {
        response = await locacoes.locais_de_estoque.removerProduto(
          this.localEstoqueId,
          form
        );
      }

      this.$emit("saved", response);
    },

    async loadProducts() {
      this.loadingProducts = true;
      try {
        this.produtos = await locacoes.products.index("");
      } catch (error) {
        console.error(error);
        this.error("Não foi possível carregar produtos");
      } finally {
        this.loadingProducts = false;
      }
    }
  },

  computed: {
    title() {
      if (this.mode === "add") {
        return "Adicionar produto";
      }

      return "Remover produto";
    }
  }
};
</script>
